import script from "./QuizPage.vue?vue&type=script&setup=true&lang=js"
export * from "./QuizPage.vue?vue&type=script&setup=true&lang=js"

import "./QuizPage.vue?vue&type=style&index=0&id=ada55e58&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ada55e58"]])

export default __exports__